<template>
  <div>
    <Header />
    <section class="mt90">
      <div class="container">
          <h3 class="text-center register-title">Welcome to Unibud !</h3>

          <div class="welcome-text">
            {{signup_survey.button_text}}
          </div>

          <template v-if="signup_survey.active === 1 && show_survey_button">
            <div class="form-group d-flex justify-content-center">
              <a v-bind:href=signup_survey.url target="_blank">
                <button class="btn btn-register" @click="survey_button_signup">{{signup_survey.button_label}}</button>
              </a>
            </div>
            <br><br>
          </template>

          <div class="form-group d-flex justify-content-center">
            <button class="btn btn-register" @click="openShopPage()">Continue To Shop</button>
          </div>

        </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from '../../components/header'
import Footer from '../../components/footer'
import {mapGetters} from "vuex";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      show_survey_button: true,
    }
  },
  computed: {
    ...mapGetters({
      survey_settings_signup: 'auth/survey_settings_signup',
      signup_survey: 'cart/signup_survey',
    }),
  },
  mounted() {
  },
  methods: {
    survey_button_signup() {
      this.show_survey_button = false;
      this.$store.dispatch('auth/surveyButtonClicked',{type: 'SIGNUP', orderid: 'N/A'});
      this.$router.push({name: 'shop'})
    },
    openShopPage() {
      this.$router.push({name: 'shop'})
    },
  },
}
</script>


<style scoped>

.welcome-text {
  color: black;
  font-size: 18px;
  text-align: center;
  margin-bottom: 37px;
}

</style>
